import { render, staticRenderFns } from "./OpportunityCandidateListTab.vue?vue&type=template&id=38dd5856"
import script from "./OpportunityCandidateListTab.vue?vue&type=script&lang=js"
export * from "./OpportunityCandidateListTab.vue?vue&type=script&lang=js"
import style0 from "./OpportunityCandidateListTab.vue?vue&type=style&index=0&id=38dd5856&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports